/** Top-level offer draft / payload keys. */
export const OfferField = Object.freeze({
	TITLE: "title",
	OFFER_CODE: "offerCode",
	DESCRIPTION: "description",
	OFFER_TYPE: "offerType",
	SUB_OFFER_TYPE: "subOfferType",
	OFFER_GROUP_ID: "offerGroupId",
	PRIORITY: "priority",
	CHANNEL: "channel",
	START_DATE: "startDate",
	END_DATE: "endDate",
	MAX_USAGE_COUNT: "maxUsageCount",
	INDIVIDUAL_MAX_USAGE_COUNT: "individualMaxUsageCount",
	USAGE_COUNT: "usageCount",
	VERSION: "version",
	STATUS: "status",
	RULE: "rule",
	OFFER_MAPPING: "offerMapping",
	MENU_LABELS: "menuLabels",
	TERMS_CONDITION: "termsCondition",
	DOCUMENT_VERSION: "__v",
});

/** Keys under offerMapping. */
export const OfferMappingField = Object.freeze({
	MENU_IDS: "menuIds",
	RESTAURANT_IDS: "restaurantIds",
	USER_IDS: "userIds",
});

/** Keys under rule. */
export const OfferRuleField = Object.freeze({
	DESCRIPTION: "description",
	OPERATOR: "operator",
	CONDITIONS: "conditions",
	ACTION: "action",
});

/** Keys under rule.action. */
export const OfferActionField = Object.freeze({
	TYPE: "type",
	VALUE: "value",
	TARGET: "target",
	MIN_AMOUNT_LIMIT: "minAmountLimit",
	MAX_AMOUNT_LIMIT: "maxAmountLimit",
});

/** Keys under rule.conditions[]. */
export const OfferConditionField = Object.freeze({
	SUBJECT: "subject",
	OPERATOR: "operator",
	VALUE: "value",
	VALUE_LABEL: "title",
});

/** Keys under termsCondition[]. */
export const OfferTermsBlockField = Object.freeze({
	TYPE: "type",
	CONTENT: "content",
});

/** Offer group draft / payload keys. */
export const OfferGroupField = Object.freeze({
	NAME: "name",
	CAN_APPLY_MULTIPLE_OFFERS: "canApplyMultipleOffers",
	COMPATIBLE_WITH: "compatibleWith",
});

/** Keys under compatibleWith. */
export const OfferCompatibleWithField = Object.freeze({
	INCLUDES: "includes",
	EXCLUDES: "excludes",
});

/** Validation error-object keys that are not direct draft paths. */
export const OfferErrorKey = Object.freeze({
	RULE_DESCRIPTION: "ruleDescription",
	CONDITIONS: "conditions",
	ACTION_TYPE: "actionType",
	ACTION_VALUE: "actionValue",
	ACTION_TARGET: "actionTarget",
});
